import React, { useState } from "react";
import Button from "../../Elements/Button/Button";
import Input from "../../Elements/Input/Input";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "./vacacionesEmpleado.css";

const yearActual = new Date().getFullYear();

export default function VacacionesEmpleado({
  vacacionesTomadas = [],
  diasDisponibles = 0,
  onAddVacacion
}) {
  const [showPicker, setShowPicker] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [folio, setFolio] = useState("");

  // Mínimo selectable: mañana
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  // Fechas que ya están ocupadas
  const disabledDates = vacacionesTomadas.flatMap(vac => vac.fechas || []);

  // Cantidad de días seleccionados
  const diasSeleccionados = selectedDates.length;

  // Formatea fechas a YYYY-MM-DD
  const fechasFormateadas = selectedDates.map(d => d.format("YYYY-MM-DD"));

  const handleSave = () => {
    if (!folio.trim() || diasSeleccionados < 1 || diasSeleccionados > diasDisponibles) return;
    onAddVacacion({ anio: yearActual, dias: diasSeleccionados, fechas: fechasFormateadas, folio });
    setSelectedDates([]);
    setFolio("");
    setShowPicker(false);
  };

  return (
    <div className="vacaciones-empleado">
      <div className="mb-3">
        <Input
          variant="Simple"
          label="Folio"
          name="folio"
          value={folio}
          onChange={e => setFolio(e.target.value)}
          placeholder="Ingresa folio"
        />
      </div>
      <div className="mb-3">
        <Button
          text={showPicker ? "Cancelar selección" : "Seleccionar vacaciones"}
          action={() => setShowPicker(f => !f)}
          color="blue"
          fill
          classNames="me-2"
        />
        {showPicker && (
          <div className="mt-2 date-picker-wrapper">
            <DatePicker
              multiple
              value={selectedDates}
              onChange={setSelectedDates}
              format="YYYY-MM-DD"
              minDate={tomorrow}
              disabledDates={disabledDates}
              sort
            />
            <div className="d-flex align-items-center mt-2">
              <span className="me-3">
                Días seleccionados: <b>{diasSeleccionados}</b>
              </span>
              <Button
                text="Guardar selección"
                action={handleSave}
                color="green"
                fill
                disabled={!folio.trim() || diasSeleccionados < 1 || diasSeleccionados > diasDisponibles}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
